import { IVariableData } from "./CalculatedPropertyViewData";
import IPropertyType from "../propertyType/PropertyTypeData";
import IPropertyCalculatedData from "./PropertyCalculatedData";
import IDirectionData from "../direction/directionData";
import { IInstrumentDetails } from "../measurement/InstrumentDetails";
import { ND } from "../../utilities/Constants";


export interface IFormulaDetails {
  formula: string;
  variables: IVariableData[];
}

export interface IInstrumentDetailsData {
  id: string;
  name: string;
}

export interface IPropertyViewData {
  id: string;
  name: string;

  description: string;
  customId: number;
  type: string;
  typeId: string;
  unit: string;
  decimal: number;
  propertyNameDirection?: string;
}

export default class PropertyViewData implements IPropertyViewData {
  id: string;
  name: string;

  description: string;
  customId: number;
  type: string;
  typeId: string;
  unit: string;
  decimal: number;
  propertyNameDirection?: string;

  constructor(id: string, name: string, description: string, customId: number, type: string, typeId: string,
    unit: string, decimal: number, propertyNameDirection?: string) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.customId = customId;
    this.type = type;
    this.typeId = typeId;
    this.unit = unit;
    this.decimal = decimal;
    if (propertyNameDirection !== undefined || propertyNameDirection !== null) {
      this.propertyNameDirection = propertyNameDirection;
    } else {
      this.propertyNameDirection = name;
    }
  }
}

export interface IPropertyDetailViewData extends IPropertyViewData {
  formula: string;
  formulaDetails: IFormulaDetails;
}

// tslint:disable-next-line: max-classes-per-file
export class PropertyDetailViewData implements IPropertyDetailViewData {
  id: string;
  name: string;

  description: string;
  customId: number;
  type: string;
  typeId: string;
  unit: string;
  decimal: number;
  formula: string;
  formulaDetails: IFormulaDetails;
  instrumentList?: IInstrumentDetailsData[];
  directionList?: IDirectionData[];
  directions?: string;
  instrumentDetails?: string;


  constructor(id: string, name: string, description: string, customId: number, type: string, typeId: string,
    unit: string, decimal: number, formula: string, formulaDetails: IFormulaDetails, instrumentList?: IInstrumentDetailsData[],
    directionList?: IDirectionData[]) {

    this.id = id;
    this.name = name;
    this.description = description;
    this.customId = customId;
    this.type = type;
    this.typeId = typeId;
    this.unit = unit;
    this.decimal = decimal;
    this.formula = formula;
    this.formulaDetails = formulaDetails;
    const d: string[] = [];
    directionList.forEach((t: IDirectionData) => {
      if (t.name === ND) {
        d.push('--')
      } else {
        d.push(t.name)
      }

    });
    this.directions = d.toString();
    const i: string[] = [];
    instrumentList.forEach((t: IInstrumentDetailsData) => i.push(t.name));
    this.instrumentDetails = i.toString();
  }
}
const defaultPropertyData = new PropertyDetailViewData("", "", "", 0, "", "", "", 0, "", { formula: "", variables: [] }, [], []);
const defaultPropertyViewData = new PropertyViewData("", "", "", 0, "", "", "", 0);
export { defaultPropertyData, defaultPropertyViewData };
